import { useState, useEffect } from 'react';

export type UserRole = 'admin' | 'manager' | 'user';

interface UserRoleData {
  role: UserRole;
  isAdmin: boolean;
}

/**
 * Hook to get the current user's role
 * For demo purposes, this reads from localStorage
 * In production, this would integrate with your auth system
 */
export function useUserRole(): UserRoleData {
  const [role, setRole] = useState<UserRole>('admin'); // Default to admin for demo

  useEffect(() => {
    // Try to get role from localStorage
    const savedRole = localStorage.getItem('userRole') as UserRole;
    if (savedRole && ['admin', 'manager', 'user'].includes(savedRole)) {
      setRole(savedRole);
    } else {
      // Default to admin for demo mode
      localStorage.setItem('userRole', 'admin');
      setRole('admin');
    }
  }, []);

  return {
    role,
    isAdmin: role === 'admin',
  };
}

/**
 * Helper function to set user role (for demo/testing purposes)
 */
export function setUserRole(role: UserRole) {
  localStorage.setItem('userRole', role);
  window.location.reload(); // Reload to apply changes
}
